import {providers, provider} from 'helpers/Providers'
import {mergeDeep} from 'helpers/Utils'

const common = {
  size: {
    font: 14,
    lineHeight: 1.2,
    space: 8,
    hairline: 1,
    bar: 44,
    icon: 24,
    maxWidth: 900
  },
  devices: {
    mobileWidth: 414,
    mobileHeight: 667,
    desktopWidth: 720 // 40em
  }
}

const themes = {
  main: {
    fontSize: {
      small: Math.round(common.size.font * 0.85) + 'px',
      regular: common.size.font + 'px',
      big: Math.round(common.size.font * 1.15) + 'px'
    },
    color: {
      primary: '#C21942', // Cardinal
      secondary: '#6E6D6E', // Dove Gray
      placeholder: '#A19FA1', // Star Dust
      rowBackground: '#FAFAFA', // Alabaster
      hairline: '#E5E6E5', // Mercury
      backdrop: 'rgba(0,0,0,0.2)', // Iron
      background: '#FFFFFF', // White
      errorBackground: '#FFF0F0', // Forget Me Not
      errorText: '#FF0000', // Red
      warningBackground: '#FFFBE6', // Early Down,
      warningText: '#5C3B00' // Saddle Brown
    },
    fontFamily: 'Lato',
    fontWeight: 300,
    lineHeight: common.size.lineHeight,
    size: {
      space: [
        0,
        common.size.space + 'px',
        common.size.space * 2 + 'px',
        common.size.space * 3 + 'px',
        common.size.space * 4 + 'px',
        common.size.space * 5 + 'px',
        common.size.space * 6 + 'px',
        common.size.space * 7 + 'px',
        common.size.space * 8 + 'px'
      ],
      hairline: common.size.hairline + 'px',
      bar: common.size.bar + 'px',
      icon: common.size.icon + 'px'
    }
  },
  [providers.redsys]: {
    color: {
      primary: '#FB6325' // Crayon Orange
    }
  }
}

mergeDeep(themes.main, themes[provider])

export const theme = {...themes.main, common}

export default theme

export const easing = {
  spring: 'cubic-bezier(0.23, 1, 0.32, 1)'
}

export const mediaQueries = {
  desktop: `@media screen and (min-width: ${common.devices.desktopWidth}px)`,
  mobile: `@media screen and (max-width: ${common.devices.desktopWidth-1}px)
  , (orientation: landscape)`,
}
// @media screen and (orientation: landscape)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Theme.ts